const theme = {
  lightOrange: "#f3a683",
  orange: "#f19066",
  black: "rgba(0, 0, 0, 0.7)",
};

export default theme;
